import { api } from "roboflex-thalamus-request-handler";
export default {
    async getDemandas(idUsuario){
        const response = await api.get(`demanda/listar/${idUsuario}?apenas_minhas=1`);
        return response.data.data;
    },
    async getTarefas(payload) {
        payload.statusProjetoPa = [
            {
                "valor": "Pendente"
            },
            {
                "valor": "Aprovado"
            },
            {
                "valor": "Em andamento"
            },
            {
                "valor": "Concluído"
            }
        ],
            payload.statusTarefa = [
                {
                    "label": "A iniciar",
                    "valor": "Pendente"
                },
                {
                    "label": "Em andamento",
                    "valor": "Em andamento"
                }
            ]
        const response = await api.post("gestao/tarefasUsuario", payload);
        return response.data;
    },
    async getSubordinados(idCoordenador) {
        const response = await api.post(`setor/responsavel/usuario`, { usuario_id: idCoordenador })
        return response.data
    },
    async getNoticias(todas = false) {
        const params = todas ? { todas: 1 } : {};
        const response = await api.get('noticias', { params });
        return response.data;
    },
    async createNoticia(payload) {
        const response = await api.post('noticias', payload);
        return response.data;
    },
    async deleteNoticia(id) {
        await api.delete(`noticias/${id}`);
    },

    /**
     * Reuniões do Google Calendar (requer conta Google conectada).
     * Em caso de 403 com code 'google_not_connected', o chamador deve exibir aviso para conectar.
     */
    async getReunioesGoogle() {
        const response = await api.get('google/calendar/reunioes');
        return response.data;
    },
};